import { StoryScreen } from '../features/stories/StoryScreen'
import { useShell } from '../app/outlet'
import { env } from '../config/env'
import { NotFoundPage } from './NotFoundPage'

export function StoryPage() {
  const { toast } = useShell()
  return env.features.stories ? <StoryScreen onToast={toast} /> : <NotFoundPage />
}
